export default {
    dekiloknaller: {
        label: "The Discounter",
        slug: "dekiloknaller",
        location: "Gush Etzion"
    },
    destandvastige: {
        label: "The Perseverer",
        slug: "destandvastige",
        location: "Jerusalem"
    },
    dedemonstrant: {
        label: "The Protester",
        slug: "dedemonstrant",
        location: "Ramallah"
    },
    devrienden: {
        label: "Friends",
        slug: "devrienden",
        location: "Jenin"
    },
    depuber: {
        label: "The Teenager",
        slug: "depuber",
        location: "Kiryat Arba"
    },
    deheilige: {
        label: "The Holy Rachel",
        slug: "deheilige",
        location: "Bethlehem"
    },
    depionier: {
        label: "The Pioneer",
        slug: "depionier",
        location: "Amona"
    },
    nazareth: "nazareth",
    golan: "syria",
    libanon: "lebanon",
    gaza: "gaza",
    israel: "Israel",
    westelijke: "West",
    jordaanoever: "Bank",
    jordanie: "jordan",
    egypte: "egypt",
    telaviv: "tel aviv",
    jeruzalem: "Jerusalem",
    beersjeva: "beer sheva",
    route60: "route 60",
    areaa: "areaa",
    areab: "areab",
    areac: "areac",
    jenin: "Jenin",
    hebron: "hebron",
    ramallah: "ramallah"
}



// WEBPACK FOOTER //
// ./src/data/maps.js